"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withApiUrl = exports.getApiUrl = void 0;
var isClientSide = function () { return typeof window !== "undefined"; };
var discoverHost = function (req) {
    return req.headers.host || req.headers["x-forwarded-host"];
};
var discoverProtocol = function (req, host) {
    if (host.includes("localhost"))
        return "http";
    // if it is a Vercel deployment, this will probably be present and we can assume it is secure
    if (req.headers["x-now-deployment-url"])
        return "https";
    // if Next.js is running on a custom server, like Express, req.protocol will probably be available
    return req["protocol"] || "https";
};
exports.getApiUrl = function (ctx, apiSufix) {
    if (apiSufix === void 0) { apiSufix = true; }
    // checking if it is client side, in case of using getInitialProps
    if (isClientSide())
        return apiSufix ? "/api" : "";
    if (!(ctx === null || ctx === void 0 ? void 0 : ctx.req)) {
        throw new Error("Invalid request");
    }
    var host = discoverHost(ctx === null || ctx === void 0 ? void 0 : ctx.req);
    var protocol = discoverProtocol(ctx === null || ctx === void 0 ? void 0 : ctx.req, host);
    return protocol + "://" + host + (apiSufix ? "/api" : "");
};
exports.withApiUrl = function (f) { return function (ctx) { return f(ctx, exports.getApiUrl(ctx)); }; };
exports.default = exports.getApiUrl;
